export enum ButtonVariant {
  default = "default",
  outline = "outline"
}
